export function getSiteUrl(): string {
  // Replaced at build time by Vite define
  const siteUrl = import.meta.env.VITE_SITE_URL;
  return typeof siteUrl === "string" ? siteUrl.replace(/\/+$/, "") : "https://kakobuypolska.cyou";
}